import React from 'react';
import ReportSegments from '../../../ReportSegments/ReportSegments';
import ReportByCountryComponent from '../../../../utils/ReportByCountryComponent/ReportByCountryComponent';
import { statisticsByCountry } from '../../../../config';

// Filter (segment) rows of the page: the shared ReportSegments with this page's report params and translations
export const StatisticsByCountrySegments = (props) => (
    <ReportSegments
        {...props}
        segmentKeys={(statisticsByCountry && statisticsByCountry.groupParamsSegment) || []}
        reportComponent={ReportByCountryComponent}
        translationKey="statisticsByCountry"
    />
);

export default StatisticsByCountrySegments;
